(function() {
  'use strict';
  
  angular
    .module('app.poll')
    .config(statesConfig);
      
  statesConfig.$inject = ['$stateProvider'];
    
  function statesConfig($stateProvider) {
    $stateProvider
      .state('shell.poll', {
        url: '/poll',
        templateUrl: 'app/poll/poll.html',
        controller: 'PollController as vm'
      });
  }
  
})();